export default __webpack_public_path__ + "static/media/hacker1.3e6ddfa1.png";